(function() {
    'use strict';

  angular.module('eclipseApp.checkout')
         .filter('formatUsageAllowance',
           ['$translate',
             function($translate) {
               var _self = this;
               _self.unltd = '';
               _self.gb = '';
               _self.mb = '';

               $translate('global.label.unlimited').then(function(resp){
                 console.log('@formatUsageAllowance ($translate.resp) ', resp);
                 _self.unltd = resp;
               }, function(err){
                    _self.unltd = '';
                  });

               $translate('global.unit.gb').then(function(resp){
                 console.log('@formatUsageAllowance ($translate.resp) ', resp);
                 _self.gb = resp;
               }, function(err){
                    _self.gb = '';
                  });

               $translate('global.unit.mb').then(function(resp){
                 console.log('@formatUsageAllowance ($translate.resp) ', resp);
                 _self.mb = resp;
               }, function(err){
                    _self.mb = '';
                  });


               return function(input, param, outputUnit) {

                 var _input, _outputUnit;

                 // define known units
                 var unit = {
                   gb: 'gb',
                   mb: 'mb'
                 };

                 // define know unlimited values expected from server side response
                 var unlimitedKeys = ['unlimited', 'unltd'];


                 if (input && param) {
                   // check usageAllowance value format as multiple digits first followed by unit

                   // input:Array
                   _input = input.match(/(\d+)(\D+)/);

                   if (!_input && param === 'amount') {
                     // handle unlimited case

                     if (input.toLowerCase() === 'unlimited' ||
                         input.toLowerCase() === 'unltd') {
                       return _self.unltd;
                     }
                     return '';
                     // return input;
                   }

                   if (param && angular.isArray(_input) && _input.length > 1) {
                     // handle limited case

                     switch (param) {
                       case 'amount':
                       return _input[1];
                       case 'unit':

                       for (var _targetOutputUnit in unit) {
                         _outputUnit = _input[2].toLowerCase().match(_targetOutputUnit);
                         if (_outputUnit && _outputUnit.length) {

                           return _self[_outputUnit[0]].toUpperCase();
                           // return _outputUnit[0].toUpperCase();
                         }
                       }

                       return _input[2];
                       default:
                     }

                   }
                 }

               };
             }]);
})();
